export type CedulaValidateOpts = {
  allowForeign?: boolean;
  foreignPrefixes?: string[];
  allowExceptionList?: boolean;
};

const DEFAULT_OPTS: CedulaValidateOpts = {
  allowForeign: true,
  foreignPrefixes: ["881"],
  allowExceptionList: true,
};

const EXCEPTIONS = new Set([
  "00000000018",
  "11111111123",
  "00100759932",
  "00105606543",
  "00114272360",
  "00200123640",
  "00200409772",
  "00800106971",
  "01200004166",
  "01400074875",
  "01400000282",
  "03103749672",
  "03200066940",
  "03800032522",
  "03900192284",
  "04900026260",
  "05900072869",
  "07700009346",
  "00114532330",
  "03121982479",
  "40200700675",
  "40200639953",
  "00121581750",
  "00119161853",
  "22321581834",
  "00121581800",
  "09421581768",
  "22721581818",
  "90001200901",
  "00301200901",
  "40200452735",
  "40200401324",
  "10621581792",
]);

export function validateCedulaRD(
  input: string,
  options?: Partial<CedulaValidateOpts>
): boolean {
  const opts = { ...DEFAULT_OPTS, ...(options || {}) };
  if (typeof input !== "string") return false;

  const digits = input.replace(/\D/g, "").trim();
  if (!/^\d{11}$/.test(digits)) return false;
  if (digits.startsWith("000")) return false;

  if (opts.allowExceptionList && EXCEPTIONS.has(digits)) return true;

  if (passesOfficialChecksum(digits)) return true;

  if (
    opts.allowForeign &&
    opts.foreignPrefixes!.some((p) => digits.startsWith(p))
  ) {
    return true;
  }

  return false;
}

function passesOfficialChecksum(d11: string): boolean {
  const verifier = Number(d11.charAt(10));
  const base10 = d11.substring(0, 10);
  const multipliers = "1212121212";

  let sum = 0;
  for (let i = 0; i < 10; i++) {
    const n = Number(base10.charAt(i));
    const m = Number(multipliers.charAt(i));
    const prod = n * m;
    sum += prod < 10 ? prod : Math.floor(prod / 10) + (prod % 10);
  }
  const remainder = (10 - (sum % 10)) % 10;
  return remainder === verifier;
}
